<template>
	<div class="yj-select-page">
		<yj-button type="text" class="first" :disabled="!first" @click="pageChange('first')">首页</yj-button>
		<yj-button type="text" class="pre" :disabled="!pre" @click="pageChange('pre')">上一页</yj-button>
		<yj-button type="text" class="next" :disabled="!next" @click="pageChange('next')">下一页</yj-button>
		<yj-button type="text" class="last" :disabled="!last" @click="pageChange('last')">尾页</yj-button>
	</div>
</template>

<script>
	export default {
		name: 'YjSelectPage',
		
		componentName: 'YjSelectPage',
		
		props: {
			page: {
				type: Number,
				default: 1
			},
			size: {
				type: Number,
				default: 5
			},
			total: {
				type: Number,
				default: 0
			},
		},
		
		computed: {
			totalPage() {
				return Math.floor((this.total + (this.size - 1)) / this.size);
			},
			first() {
				return !this.loading && this.page != 1;
			},
			pre() {
				return !this.loading && this.page > 1;
			},
			next() {
				return !this.loading && this.page < this.totalPage;
			},
			last() {
				return !this.loading && this.page != this.totalPage;
			}
		},
		
		methods: {
			pageChange(sign) {
				if (sign == 'first') {
					//首页
					this.$emit('page-change', 1);
				} else if (sign == 'pre') {
					//上一页
					this.$emit('page-change', this.page - 1);
				} else if (sign == 'next') {
					//下一页
					this.$emit('page-change', this.page + 1);
				} else if (sign == 'last') {
					//尾页
					this.$emit('page-change', this.totalPage);
				}
			}
		}
	}
	
</script>




// WEBPACK FOOTER //
// src/components/select/src/select-page.vue